import { render, staticRenderFns } from "./manage-extrafields.vue?vue&type=template&id=0365de58&scoped=true"
import script from "./manage-extrafields.vue?vue&type=script&lang=js"
export * from "./manage-extrafields.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./manage-extrafields.vue?vue&type=style&index=1&id=0365de58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365de58",
  null
  
)

export default component.exports